import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { apiHolder as api, apis } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import PageContentLayout from '@/layouts/Main/pageContentLayout';
import './mailBox.scss';
import MailColumnEntry from './components/MailColumnEntry/AiMailColumnEntry';
import useState2RM from './hooks/useState2ReduxMock';
import useGetUniqReqWrap from '@web-common/hooks/useGetUniqReqWrap';
import { getMainContOffsetTopHeight } from '@web-common/utils/waimao';
import MailColumnEntryContainer from '@web-mail/components/ReadMailPageContainer/MailColumnEntryContainer';
import MainReadMailWrap, { RightSider } from '@web-mail/readMailAndSider';
import useAppScale from '@web-mail/hooks/useAppScale';
import useStateRef from '@web-mail/hooks/useStateRef';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
const systemApi = api.api.getSystemApi();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const performance = api.api.requireLogicalApi(apis.performanceImpl);
const height = systemApi.isWebWmEntry() ? `calc(100vh - 36px - ${getMainContOffsetTopHeight()}px)` : '100%';
const AiAsstReadMailPage = props => {
    const { openInNewWindow = false, mailId = '', from = '', active } = props;
    const currentTabQuery = useAppSelector(state => {
        var _a, _b, _c, _d;
        return {
            query: (_b = (_a = state.mailTabReducer.currentTab) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.query,
            accountId: (_d = (_c = state.mailTabReducer.currentTab) === null || _c === void 0 ? void 0 : _c.extra) === null || _d === void 0 ? void 0 : _d.accountId,
        };
    });
    const [selectedMail, setSelectedMail] = useState2RM('AI_tab_selectedMailId');
    const [, setMailListResizeProcessing] = useState2RM('mailListResizeProcessing');
    const [mailTPDetailQuery] = useState2RM('mailTPDetailQuery');
    const isLeftRight = true;
    const isUpDown = false;
    const [, setQuickSettingVisible] = useState2RM('configMailShow', 'doUpdateConfigMailShow');
    const [mailEntities] = useState2RM('mailEntities');
    const showReadMail = true;
    useMemo(() => {
        try {
            if ((selectedMail === null || selectedMail === void 0 ? void 0 : selectedMail.id) != null) {
                performance.time({
                    statKey: 'mail_readmail_switch',
                    statSubKey: '',
                    params: {
                        mailId: selectedMail === null || selectedMail === void 0 ? void 0 : selectedMail.id,
                        accountId: (selectedMail === null || selectedMail === void 0 ? void 0 : selectedMail.accountId) + '',
                    },
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    }, [(selectedMail === null || selectedMail === void 0 ? void 0 : selectedMail.id) + '' + (selectedMail === null || selectedMail === void 0 ? void 0 : selectedMail.accountId)]);
    const showMailColumn = true;
    const readMailUniqWarp = useGetUniqReqWrap();
    useEffect(() => {
        if (active) {
            setQuickSettingVisible(false);
        }
    }, [active]);
    const appColumnSize = useAppScale();
    const mailListWidthRef = useStateRef(appColumnSize.mailListWidth);
    const mailListMaxConstraintsRef = useStateRef(appColumnSize.mailListMaxConstraints);
    const mailColumnEntry = useMemo(() => {
        let outerProps = {};
        if ((isLeftRight || isUpDown) && showMailColumn) {
            let upDownProps = {
                defaultWidth: mailListWidthRef.current || appColumnSize.mailListWidth,
                defaultheight: '100%',
            };
            outerProps = upDownProps;
        }
        return (React.createElement(MailColumnEntryContainer, { height: height, showMailColumn: showMailColumn, isLeftRight: isLeftRight, isUpDown: isUpDown, upDownProps: outerProps, defaultListWidth: mailListWidthRef.current, openInNewWindow: openInNewWindow, maxWidth: mailListMaxConstraintsRef.current, setMailListResizeProcessing: setMailListResizeProcessing, SideContentLayout: true },
            React.createElement(MailColumnEntry, { isLeftRight: isLeftRight })));
    }, [isLeftRight, isUpDown, showMailColumn, openInNewWindow, mailListWidthRef.current]);
    const CurMailContent = useMemo(() => {
        return mailEntities[openInNewWindow ? mailId : selectedMail.id];
    }, [mailEntities, openInNewWindow, mailId, selectedMail.id]);
    const currentMailfrom = useMemo(() => {
        var _a, _b;
        if ((_a = currentTabQuery === null || currentTabQuery === void 0 ? void 0 : currentTabQuery.query) === null || _a === void 0 ? void 0 : _a.mid) {
            if (((_b = currentTabQuery === null || currentTabQuery === void 0 ? void 0 : currentTabQuery.query) === null || _b === void 0 ? void 0 : _b.mailFrom) === 'subordinate') {
                return 'subordinate';
            }
            else {
                return 'customer';
            }
        }
        return openInNewWindow ? from : selectedMail.from;
    }, [openInNewWindow, selectedMail.id, currentTabQuery === null || currentTabQuery === void 0 ? void 0 : currentTabQuery.query]);
    const doGetTpMailContent = useCallback((id, _noFlagInfo, noCache) => {
        var _a, _b, _c;
        const param = {
            mid: id,
            owner: CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.owner,
            subEmail: ((_a = CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.tpMailInfo) === null || _a === void 0 ? void 0 : _a.belongEmail) || (CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.owner),
            colleagueAccId: (_b = CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.tpMailInfo) === null || _b === void 0 ? void 0 : _b.colleagueAccId,
            mailFrom: CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.mailFrom,
            mainAccount: CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.mainAccount,
        };
        if ((CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.mailFrom) === 'subordinate' && ((_c = CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.tpMailInfo) === null || _c === void 0 ? void 0 : _c.subordinateFromAI)) {
            param.subordinateFromAI = true;
        }
        return mailApi.doGetTpMailContent(param, noCache);
    }, [CurMailContent]);
    const doGetTpMailContentCM = useCreateCallbackForEvent((id, _noFlagInfo, noCache) => {
        return mailApi.doGetTpMailContent({
            mid: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.mid,
            owner: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.owner,
            mailFrom: 'relatedEmail',
            mainAccount: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.mainAccount,
            type: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.type,
            refId: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.refId,
        }, noCache);
    });
    const doGetTpMailContentSD = useCallback((id, _noFlagInfo, noCache) => {
        return mailApi.doGetTpMailContent({
            mid: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.mid,
            owner: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.owner,
            subEmail: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.owner,
            mailFrom: 'subordinate',
            colleagueAccId: mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.colleagueAccId,
            subordinateFromAI: true,
        }, noCache);
    }, [currentTabQuery === null || currentTabQuery === void 0 ? void 0 : currentTabQuery.query, mailTPDetailQuery]);
    const [currentMailId, lock] = useMemo(() => {
        if (openInNewWindow) {
            return [mailId];
        }
        return [selectedMail.id || '', selectedMail === null || selectedMail === void 0 ? void 0 : selectedMail.lock];
    }, [openInNewWindow, mailId, selectedMail.id]);
    const readMail = useMemo(() => {
        let getSignMailContent;
        if (CurMailContent && (CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.isTpMail)) {
            getSignMailContent = doGetTpMailContent;
        }
        if (currentMailfrom == 'customer') {
            if (!!(mailTPDetailQuery === null || mailTPDetailQuery === void 0 ? void 0 : mailTPDetailQuery.isSelf)) {
                getSignMailContent = null;
            }
            else {
                getSignMailContent = doGetTpMailContentCM;
            }
        }
        else if (currentMailfrom == 'subordinate') {
            getSignMailContent = doGetTpMailContentSD;
        }
        return (React.createElement(MainReadMailWrap, { SideContentLayout: true, showReadMail: showReadMail, id: currentMailId, height: isUpDown ? '100%' : height, isUpDown: isUpDown, from: from, openInNewWindow: openInNewWindow, tempContent: CurMailContent, requestUniqWrap: readMailUniqWarp, readOnly: CurMailContent && (CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.isTpMail), getSignMailContent: getSignMailContent, emptyRender: () => null }));
    }, [showReadMail, openInNewWindow, currentMailId, doGetTpMailContent, doGetTpMailContentSD, CurMailContent === null || CurMailContent === void 0 ? void 0 : CurMailContent.id, currentMailfrom]);
    const rightSiderMemo = useMemo(() => React.createElement(RightSider, { "data-sidecontent": true, id: currentMailId, lock: lock }), [currentMailId, lock]);
    const [style] = useState({ display: 'flex', flex: 1, overflow: 'hidden', height: '100%' });
    const listAndContent = useMemo(() => {
        return (React.createElement(React.Fragment, null,
            mailColumnEntry,
            readMail,
            rightSiderMemo));
    }, [isUpDown, openInNewWindow, mailColumnEntry, readMail, rightSiderMemo]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageContentLayout, { style: style }, listAndContent)));
};
export default AiAsstReadMailPage;
